import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PAGE_FORMATS, ORIENTATIONS, DEFAULT_MARGINS } from '../../utils/constants';
import './style.css';

export default function PageSettings({ settings, onSettingsChange, onMarginsChange }) {
  const { format, orientation, margins } = settings;

  return (
    <div className="page-settings">
      {/* Page Format */}
      <div className="settings-group">
        <div className="settings-group-title">Formato Pagina</div>

        <div className="settings-row">
          <label className="settings-label">Dim.</label>
          <select
            className="settings-select"
            value={format}
            onChange={e => onSettingsChange({ format: e.target.value })}
          >
            {Object.entries(PAGE_FORMATS).map(([key, val]) => (
              <option key={key} value={key}>
                {val.label} ({val.width} x {val.height} mm)
              </option>
            ))}
          </select>
        </div>

        <div className="settings-row">
          <label className="settings-label">Orientamento</label>
          <div className="orientation-buttons">
            <button
              className={`orientation-btn ${orientation === ORIENTATIONS.PORTRAIT ? 'active' : ''}`}
              onClick={() => onSettingsChange({ orientation: ORIENTATIONS.PORTRAIT })}
            >
              <div className="orientation-icon portrait"></div>
              <span>Verticale</span>
            </button>
            <button
              className={`orientation-btn ${orientation === ORIENTATIONS.LANDSCAPE ? 'active' : ''}`}
              onClick={() => onSettingsChange({ orientation: ORIENTATIONS.LANDSCAPE })}
            >
              <div className="orientation-icon landscape"></div>
              <span>Orizzontale</span>
            </button>
          </div>
        </div>
      </div>

      {/* Margins */}
      <div className="settings-group">
        <div className="settings-group-title">
          Margini (mm)
          <button
            className="reset-margins-btn"
            onClick={() => onMarginsChange(DEFAULT_MARGINS)}
            title="Ripristina valori predefiniti"
          >
            <FontAwesomeIcon icon="undo" />
          </button>
        </div>

        <div className="margins-grid">
          <div className="margin-row top">
            <label>Sopra</label>
            <input
              type="number"
              value={margins.top}
              onChange={e => onMarginsChange({ top: parseInt(e.target.value) || 0 })}
              min="0"
              max="100"
            />
          </div>

          <div className="margin-row sides">
            <div className="margin-input left">
              <label>Sinistro</label>
              <input
                type="number"
                value={margins.left}
                onChange={e => onMarginsChange({ left: parseInt(e.target.value) || 0 })}
                min="0"
                max="100"
              />
            </div>

            <div className="margin-preview">
              <div
                className="margin-preview-inner"
                style={{
                  margin: `${margins.top * 0.5}px ${margins.right * 0.5}px ${margins.bottom * 0.5}px ${margins.left * 0.5}px`
                }}
              />
            </div>

            <div className="margin-input right">
              <label>Destro</label>
              <input
                type="number"
                value={margins.right}
                onChange={e => onMarginsChange({ right: parseInt(e.target.value) || 0 })}
                min="0"
                max="100"
              />
            </div>
          </div>

          <div className="margin-row bottom">
            <label>Sotto</label>
            <input
              type="number"
              value={margins.bottom}
              onChange={e => onMarginsChange({ bottom: parseInt(e.target.value) || 0 })}
              min="0"
              max="100"
            />
          </div>
        </div>
      </div>

      {/* Page Info */}
      <div className="settings-group">
        <div className="settings-group-title">Info Pagina</div>
        <div className="page-info">
          <div className="page-info-row">
            <span>Dimensione:</span>
            <span>
              {orientation === ORIENTATIONS.LANDSCAPE
                ? `${PAGE_FORMATS[format]?.height} x ${PAGE_FORMATS[format]?.width}`
                : `${PAGE_FORMATS[format]?.width} x ${PAGE_FORMATS[format]?.height}`
              } mm
            </span>
          </div>
          <div className="page-info-row">
            <span>Area Contenuto:</span>
            <span>
              {(orientation === ORIENTATIONS.LANDSCAPE
                ? PAGE_FORMATS[format]?.height
                : PAGE_FORMATS[format]?.width) - margins.left - margins.right
              } x {
                (orientation === ORIENTATIONS.LANDSCAPE
                  ? PAGE_FORMATS[format]?.width
                  : PAGE_FORMATS[format]?.height) - margins.top - margins.bottom
              } mm
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
